import {WarehouseGroup} from '@common/graphql/API';

export type WarehouseInputs = {
  warehouseGroup: WarehouseGroup | null;
};

export const initialWarehouseInputs: WarehouseInputs = {
  warehouseGroup: null,
};
